/**
 * @generated SignedSource<<8cdefdef6f36cb27c74a011385d7d8b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemDescriptionContentProducts_products$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemProducts_WorkspaceProduct">;
  readonly " $fragmentType": "ListItemDescriptionContentProducts_products";
}>;
export type ListItemDescriptionContentProducts_products$key = ReadonlyArray<{
  readonly " $data"?: ListItemDescriptionContentProducts_products$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentProducts_products">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemDescriptionContentProducts_products",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoListItemProducts_WorkspaceProduct"
    }
  ],
  "type": "WorkspaceProduct",
  "abstractKey": null
};

(node as any).hash = "731d4c478759f00fd3429bfcf38b0bef";

export default node;
